import { defineRecipe } from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
  base: {
    borderRadius: 'md',
    _currentPage: {
      fontWeight: 'bold'
    }
  }
})
